export default {
    props: {
        disabled: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        size: { type: String, default: 'medium', validator: (value) => [ 'medium', 'small', 'mini' ].includes(value) },
    },
};
